import { render, staticRenderFns } from "./Faqs_page.vue?vue&type=template&id=680c7a68&scoped=true&"
import script from "./Faqs_page.vue?vue&type=script&lang=js&"
export * from "./Faqs_page.vue?vue&type=script&lang=js&"
import style0 from "./Faqs_page.vue?vue&type=style&index=0&id=680c7a68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c7a68",
  null
  
)

export default component.exports